export default "__VITE_ASSET__45e67af3__"